import { Button } from '@studio/design-system/button';
import {
  NotificationStack as DesignSystemNotificationStack,
  Notice
} from '@studio/design-system/notification';
import { useState } from 'react';
import type { ReactElement } from 'react';
import { Column, Exhibit } from './styled.jsx';
import { Sel, STagNew } from '#~/stag/index.js';

const stackNotifications = [
  {
    id: 'exhibit-notification-stack-1',
    message: 'Short status update.',
    severity: 'success',
    title: 'Encoder Online'
  },
  {
    id: 'exhibit-notification-stack-2',
    message: 'Synthetic local notification with one normal line of detail.',
    severity: 'warning',
    title: 'Layer check B'
  },
  {
    id: 'exhibit-notification-stack-3',
    message:
      'Iris is unable to connect to yeet. Please check your internet connection, or restart yeet.',
    severity: 'error',
    title: 'yeet Disconnected'
  },
  {
    id: 'exhibit-notification-stack-4',
    message:
      'A longer restore failure message keeps this toast taller, so the exhibit catches spacing regressions between mixed-height cards.',
    severity: 'error',
    title: 'Device not restored'
  }
] as const;

/** `<NotificationStack>` exhibit. */
export const NotificationStack = (): ReactElement => {
  const [notifications, setNotifications] =
    useState<readonly (typeof stackNotifications)[number][]>(stackNotifications);

  const clearStackNotifications = (): void => {
    setNotifications([]);
  };

  const seedStackNotifications = (): void => {
    setNotifications(stackNotifications);
  };

  return (
    <>
      <Exhibit title='Notification Stack'>
        <Column className='w-prompt'>
          <div className='flex gap-12'>
            <Button
              onClick={seedStackNotifications}
              type='button'
              variant='primary'
              {...STagNew(Sel.NotificationStackExhibit, 'seed_stack')}
            >
              Seed stack
            </Button>
            <Button
              onClick={clearStackNotifications}
              type='button'
              variant='secondary'
              {...STagNew(Sel.NotificationStackExhibit, 'clear_stack')}
            >
              Clear stack
            </Button>
          </div>
        </Column>
      </Exhibit>

      <div className='pointer-events-none absolute inset-y-0 right-0 z-70' data-theme='light'>
        <div className='flex h-full items-end justify-end overflow-visible py-24'>
          <DesignSystemNotificationStack className='mt-auto' itemClassName='pr-24'>
            {notifications.map((notification) => (
              <Notice
                closeable
                collapsible={false}
                key={notification.id}
                notification={notification}
                onClose={() => {
                  setNotifications((currentNotifications) =>
                    currentNotifications.filter(({ id }) => id !== notification.id)
                  );
                }}
              />
            ))}
          </DesignSystemNotificationStack>
        </div>
      </div>
    </>
  );
};
